import { api } from "@/builders/axios";
import { FilterParams } from "@/builders/types/filter-params";

const get = function (link: string, params?: FilterParams) {
  return api.get<{
    count: number;
    next: string;
    previous: string;
    results: Array<{
      names: Array<string>;
    }>;
  }>(`organizations/${link}/domain-names`, {
    params,
  });
};

const post = function (link: string, data: { names: Array<string> }) {
  return api.post(`organizations/${link}/domain-names`, data);
};

export const domain_names = {
  get,
  post,
};
